import * as axios from "axios";
import { webStore, clearAuth } from "store";

var axiosObject = axios.default.create();

axiosObject.defaults.baseURL = process.env.NEXT_PUBLIC_API_URL;

axiosObject.defaults.headers.common = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

axiosObject.interceptors.request.use(
  async function (config: any) {
    config.headers["Authorization"] = `Bearer ${
      process.env.NEXT_PUBLIC_APP_NAME === "banker"
        ? webStore.getState().bankerAuth?.accessToken
        : process.env.NEXT_PUBLIC_APP_NAME === "bidder"
        ? webStore.getState().bidderAuth?.accessToken
        : process.env.NEXT_PUBLIC_APP_NAME === "buyer"
        ? webStore.getState().buyerAuth?.accessToken
        : process.env.NEXT_PUBLIC_APP_NAME === "seller"
        ? webStore.getState().sellerAuth?.accessToken
        : process.env.NEXT_PUBLIC_APP_NAME === "admin"
        ? webStore.getState().adminAuth?.accessToken
        : webStore.getState().auth?.accessToken
    }`;
    return config;
  },
  function (error: any) {
    return Promise.reject(error);
  }
);

axiosObject.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error: any) {
    if (error.message.includes("500")) {
      console.log("server error!");
    } else if (error.message.includes("403")) {
      webStore.dispatch(clearAuth());
    }
    return Promise.reject(error);
  }
);

export { axiosObject };
